// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "resolve-claim";

export const resolveClaimSchema = z.object({}).strict();

export const resolveClaimParamsSchema = z
  .object({
    claimId: z.string(),
  })
  .strict();




export type ResolveClaim = z.infer<typeof resolveClaimSchema>;

export type ResolveClaimParams = z.infer<typeof resolveClaimParamsSchema>;




// receiver/resolve-claim endpoint
export function resolveClaim(
  params: z.input<typeof resolveClaimParamsSchema>
): Promise<void> {
  return requestHandler(
    "receiver/resolve-claim",
    params,
    undefined,
  );
}

